import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppRoutes } from '../../app.routes';

export const FirstLoginGuardCanActivate: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthorized()) {
        return router.createUrlTree([AppRoutes.Login]);
    }

    if (!authService.shouldChangePassword()) {
        return router.createUrlTree([AppRoutes.Auctions]);
    }

    return true;
};
